import { useQuery } from "@tanstack/react-query";

import type { getTidLinkedAccountTypes } from "@/api/graphql/billing/searchTidLinkedAccountTypes/api";
import { createSearchTidLinkedAccountTypesQueryOptions } from "@/api/graphql/billing/searchTidLinkedAccountTypes/queryOptions";

export const useTidLinkedAccountTypes = ({
  getTidLinkedAccountTypesFn,
}: {
  getTidLinkedAccountTypesFn: typeof getTidLinkedAccountTypes;
}) =>
  useQuery(
    createSearchTidLinkedAccountTypesQueryOptions({
      getTidLinkedAccountTypesFn,
    }),
  );
